import styles from './user-options.module.scss';
import useSession from '@/hooks/useSession';
import DoorOpenIcon from '@/assets/icons/door-open-solid.svg?react';
import FeedbackCTA from '@/components/FeedbackCTA';
import { storeCurrentOrg } from '@/services/org.service';

const UserOptions = ({ collapsed = false }) => {
  const {
    session: { email, organizations },
    orgIndex,
    setOrgIndex,
    refreshSession,
    logout,
  } = useSession();

  const handleLogOut = async () => {
    // logout() handles navigation:
    // - For SSO: redirects to Zitadel end_session URL
    // - For password auth: navigates to /sign-in
    await logout();
  };
  return (
    <div className={styles['user-options']}>
      {!collapsed && (
        <div className={styles['user-details']}>
          <p className={styles['user-email']}>
            {email.split('@').map((text, index) => (
              <span className={styles['user-email-part']} key={index}>
                {index === 1 && '@'}
                {text}
              </span>
            ))}
          </p>
        </div>
      )}
      {organizations.length > 1 && (
        <select
          className={styles['org-select']}
          value={orgIndex}
          onChange={(e) => {
            const newOrgIndex = Number(e.target.value);
            if (newOrgIndex !== orgIndex) {
              setOrgIndex(newOrgIndex);
              storeCurrentOrg(organizations[newOrgIndex].id);
              refreshSession();
            }
          }}
        >
          {organizations.map((org, index) => (
            <option key={org.name} value={index}>
              {org.name}
            </option>
          ))}
        </select>
      )}
      <FeedbackCTA text={collapsed ? '' : 'Share Feedback'} />

      <button className={styles['logout']} onClick={handleLogOut}>
        <DoorOpenIcon />
        {!collapsed && 'Log out'}
      </button>
    </div>
  );
};

export default UserOptions;
